import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GetPictureService } from "../../../app/shared/services/files/getPictures.service";
import { MaskService } from "../../../app/shared/services/mask/mask.service";
import { DriverService } from "../shared/driver.service";
import { LessorService } from "../../lessor/shared/lessor.service";
import { ToastrService } from "ngx-toastr";
import { StatesServices } from "../../shared/services/states/states.service";
import { FileUploadService } from "../../../app/shared/services/files/fileUpload.service";
import { DriverHireDateService } from "../shared/driverHireDate.service";
import { CanComponentDeactivate } from "../../shared/guards/confirmation/confirmation.guard";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";
import { DriverViewModel } from "@app/shared/models/drivers/DriverViewModel.model";
import { DriverValidationService } from "../shared/driverValidation.service";
import { FeatureFlagsService } from "@app/agilx/shared/feature-flags.service";

@Component({
  selector: "app-driverinfo",
  templateUrl: "./driverinfo.component.html",
  styleUrls: ["./driverinfo.component.css"],
})
export class DriverinfoComponent implements OnInit, CanComponentDeactivate {
  @ViewChild("driverDocuments", { static: true }) driverDocuments;

  id: string;
  driverInfo: DriverViewModel = new DriverViewModel();
  is_edit: boolean;
  btnProfile: string;
  dateMask: (string | RegExp)[];
  socialSecurityMask = [];
  usPhoneMask: any;
  drivers: DriverViewModel[] = [];
  allDrivers: DriverViewModel[] = [];
  docType: string;
  newEvent: any;
  isProcessing = false;
  driverSelected = null;
  states = [];
  originalInfo: any;
  newProfileFile: any;
  profilePicture: any;
  lessorOwners: any = [];
  dateInputMask: any;
  constructor(
    private _driverinfo: ActivatedRoute,
    private getPictureService: GetPictureService,
    private maskService: MaskService,
    private driverService: DriverService,
    private lessorService: LessorService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private statesServices: StatesServices,
    private fileUploadService: FileUploadService,
    private driverHireDateService: DriverHireDateService,
    private _AuthService: authenticationService,
    private featureFlagsService: FeatureFlagsService,
    private driverValidationService: DriverValidationService
  ) {
    this.is_edit = true;
    this.btnProfile = "Edit Profile";
    this.docType = "driver";
  }

  ngOnInit() {
    this.lessorService.getActiveLessorList(true).subscribe((response) => {
      this.lessorOwners = response || [];
    });
    this.profilePicture = "assets/img/tractordriver.jpg";
    this.states = this.statesServices.getTwoLettersStates("US");
    this.allDrivers = this.route.snapshot.data["drivers"];
    this.drivers = this.route.snapshot.data["drivers"];
    this.newEvent = {};
    this.dateMask = this.maskService.getDate();
    this.usPhoneMask = this.maskService.getUsPhoneMask();
    this.socialSecurityMask = this.maskService.getSocialSecurityMask();
    this._driverinfo.params.subscribe((params) => {
      this.id = params["id"];
    });
    this.driverService.getDriverInfoById(this.id).subscribe((result) => {
      this.driverInfo = result;
      this.filterTeamDrivers();
      if (this.driverInfo.picture) {
        this.profilePicture = this.getFilePath(this.driverInfo.picture);
      }
      this.initDateFields(this.driverInfo);
      for (let i = 0; i < this.drivers.length; i++) {
        if (this.drivers[i].id === this.driverInfo.id) {
          this.drivers.splice(i, 1);
        }
      }
      this.driverDocuments.getDocuments(
        ("web" + this.docType + "_files").toUpperCase(),
        this.driverInfo.id
      );
    });
    this.dateInputMask = this.maskService.getInputDateOnlyMask();
  }

  filterTeamDrivers() {
    this.drivers = this.allDrivers.filter(
      (driver) => driver.type === this.driverInfo.type && driver.isActive
    );
  }

  hasPermission(permissionName: string) {
    const permission = Permissions[permissionName];
    return this._AuthService.hasPermission(permission);
  }

  canViewNewDriverPage(): boolean {
    return (
      this.featureFlagsService.isEnabled("drivers") &&
      (this.hasPermission("DriversProfileRead") || this.hasPermission("DriversRead"))
    );
  }

  goToNewDriverPage() {
    if (this.canViewNewDriverPage() && this.driverInfo?.id) {
      this.router.navigate(["/drivers", this.driverInfo.id]);
    }
  }

  confirm() {
    if (!this.is_edit) {
      return window.confirm("Are you sure you want to leave this page?");
    } else {
      return true;
    }
  }

  addDriverHireDate() {
    if (this.driverInfo.hiredDate == null) {
      this.toastr.warning("Hire date must have a from date.", "Alert!");
      return;
    }
    if (this.driverInfo.hiredDateTo == null) {
      this.driverInfo.hiredDateTo = new Date();
    }
    this.driverInfo.driverHireDates.push({
      hiredDate: this.driverInfo.hiredDate,
      hiredDateTo: this.driverInfo.hiredDateTo,
    });
    this.driverInfo.driverHireDates.sort((a, b) => {
      var aDate = new Date(a.hiredDate).getTime();
      var aDateTo = new Date(a.hiredDateTo).getTime();
      var bDate = new Date(b.hiredDate).getTime();
      var bDateTo = new Date(b.hiredDateTo).getTime();
      return aDate == bDate ? bDateTo - aDateTo : bDate - aDate;
    });
    this.driverInfo.hiredDate = null;
    this.driverInfo.hiredDateTo = null;
  }

  driverHireDateCounter() {
    if (this.driverInfo.driverHireDates)
      return new Array(this.driverInfo.driverHireDates.length + 1);
    return new Array(1);
  }

  addHireDates(driverId: string) {
    return this.driverHireDateService.createHireDates(driverId, this.driverInfo.driverHireDates);
  }

  removeDriverHireDate(index: number) {
    this.driverInfo.driverHireDates.splice(index - 1, 1);
  }

  teamSelected(driver) {
    if (!this.driverSelected) {
      driver.teamId = null;
      driver.driverTeamId = null;
      return;
    }
    if (this.driverSelected.team) {
      driver.teamId = this.driverSelected.team.id;
      driver.driverTeamId = null;
    } else {
      driver.driverTeamId = this.driverSelected.id;
      this.driverSelected.earningPercentage = 0;
      driver.teamId = null;
    }
    if (this.driverInfo.team == null) this.driverInfo.team = {};
    this.driverSelected.isPayTo = false;
    this.driverInfo.isPayTo = true;
    if (this.driverSelected.team) {
      // If the selected driver is already part of a team
      // Add us to the team (if we're not already on it) and make us the payto
      let teamDrivers = this.driverSelected.team.drivers
        .filter((driver) => driver.id !== this.driverInfo.id)
        .map((driver) => ({
          ...driver,
          isPayTo: false,
          earningPercentage: driver.earningPercentage ?? 0,
        }));
      this.driverInfo.team.drivers = [...teamDrivers, JSON.parse(JSON.stringify(this.driverInfo))];
    } else {
      this.driverInfo.team.drivers = [
        this.driverSelected,
        JSON.parse(JSON.stringify(this.driverInfo)),
      ];
    }
  }

  removeFromTeam() {
    let driver = this.driverInfo.team.drivers.find((driver) => driver.id === this.driverInfo.id);
    const oldTeamEarningPercentageTotal = this.driverInfo.team.drivers
      .filter((driver) => driver.id !== this.driverInfo.id)
      .reduce((total, driver) => total + driver.earningPercentage, 0);
    if (driver.isPayTo) {
      return this.toastr.warning(
        "Please change the Pay To driver before leaving the team",
        "Alert!"
      );
    } else if (oldTeamEarningPercentageTotal !== 100) {
      return this.toastr.warning(
        "Please change team earning to be 100% without you before you leave",
        "Alert!"
      );
    }
    this.driverInfo.previousTeam = {
      TeamId: this.driverInfo.teamId,
      Team: JSON.parse(JSON.stringify(this.driverInfo.team)),
    };
    delete driver.teamId;
    delete this.driverInfo.teamId;
    delete this.driverInfo.team;
    this.driverSelected = null;
    this.driverInfo.isPayTo = true;
  }

  calculateTotalTeamPercent() {
    return this.driverInfo.team.drivers.reduce(
      (acc, curr) => acc + (curr.earningPercentage || 0),
      0
    );
  }

  editOn(driver) {
    if (this.btnProfile === "Edit Profile") {
      this.btnProfile = "Save Changes";
      this.is_edit = false;
      this.originalInfo = JSON.stringify(this.driverInfo);
    } else {
      if (!this.validateDriver()) return;
      this.isProcessing = true;
      if (this.newProfileFile) {
        this.uploadNewImage().subscribe((url: any) => {
          driver.picture = url.name;
          this.uploadDocuments(driver.id).subscribe({
            next: () => this.updateDriver(driver),
            error: () => {
              this.toastr.error("Error uploading files");
              this.isProcessing = false;
            },
          });
        });
      } else {
        this.uploadDocuments(driver.id).subscribe({
          next: () => this.updateDriver(driver),
          error: () => {
            this.toastr.error("Error uploading files");
            this.isProcessing = false;
          },
        });
      }
    }
  }

  // was used to update the page after a driver was updated. now updating redirects you
  refreshInfo() {
    this.driverService.getDriverInfoById(this.id).subscribe((result) => {
      this.driverInfo = result;
      this.initDateFields(this.driverInfo);

      for (let i = 0; i < this.drivers.length; i++) {
        if (this.drivers[i].id === this.driverInfo.id) {
          this.drivers.splice(i, 1);
        }
      }
      this.toastr.success("Driver updated", "Success!");
      this.isProcessing = false;
      this.is_edit = true;
      this.btnProfile = "Edit Profile";
    });
  }

  convertToDate(date: any): Date | null {
    return date ? new Date(date) : null;
  }

  // Convert YYYY-MM-DD or other formats to MM/dd/yyyy for input masks
  convertDateOnlyToDisplay(dateString: any): string | null {
    if (!dateString) return null;
    const str = String(dateString);
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      const [year, month, day] = str.split("-");
      return `${month}/${day}/${year}`;
    }
    return dateString;
  }

  // Convert Date objects or MM/dd/yyyy strings to YYYY-MM-DD for the server
  convertDateToDateOnlyString(date: any): string | null {
    if (!date) return null;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    if (date instanceof Date) {
      if (isNaN(date.getTime())) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    if (typeof date === "string") {
      const parsed = new Date(date);
      if (!isNaN(parsed.getTime())) {
        const year = parsed.getFullYear();
        const month = String(parsed.getMonth() + 1).padStart(2, "0");
        const day = String(parsed.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
    }
    return null;
  }

  prepareDateOnlyFields() {
    this.driverInfo.birthDate = this.convertDateToDateOnlyString(this.driverInfo.birthDate) as any;
    this.driverInfo.hiredDate = this.convertDateToDateOnlyString(this.driverInfo.hiredDate) as any;
    this.driverInfo.hiredDateTo = this.convertDateToDateOnlyString(
      this.driverInfo.hiredDateTo
    ) as any;
    this.driverInfo.licenseExpirationDate = this.convertDateToDateOnlyString(
      this.driverInfo.licenseExpirationDate
    ) as any;
    this.driverInfo.physicalExamDate = this.convertDateToDateOnlyString(
      this.driverInfo.physicalExamDate
    ) as any;
    this.driverInfo.physicalExamExpirationDate = this.convertDateToDateOnlyString(
      this.driverInfo.physicalExamExpirationDate
    ) as any;
    this.driverInfo.annualReviewDate = this.convertDateToDateOnlyString(
      this.driverInfo.annualReviewDate
    ) as any;
    this.driverInfo.trainingDateCGMP = this.convertDateToDateOnlyString(
      this.driverInfo.trainingDateCGMP
    ) as any;
    this.driverInfo.expirationDateCGMP = this.convertDateToDateOnlyString(
      this.driverInfo.expirationDateCGMP
    ) as any;
    this.driverInfo.hazmatTrainingDate = this.convertDateToDateOnlyString(
      this.driverInfo.hazmatTrainingDate
    ) as any;
    this.driverInfo.hazmatTrainingExpirationDate = this.convertDateToDateOnlyString(
      this.driverInfo.hazmatTrainingExpirationDate
    ) as any;
    this.driverInfo.hmeExpirationDate = this.convertDateToDateOnlyString(
      this.driverInfo.hmeExpirationDate
    ) as any;
    this.driverInfo.passportExpirationDate = this.convertDateToDateOnlyString(
      this.driverInfo.passportExpirationDate
    ) as any;
    this.driverInfo.terminationDate = this.convertDateToDateOnlyString(
      this.driverInfo.terminationDate
    ) as any;

    if (this.driverInfo.driverHireDates) {
      this.driverInfo.driverHireDates = this.driverInfo.driverHireDates.map((hireDate) => ({
        ...hireDate,
        hiredDate: this.convertDateToDateOnlyString(hireDate.hiredDate) as any,
        hiredDateTo: this.convertDateToDateOnlyString(hireDate.hiredDateTo) as any,
      }));
    }
  }

  initDateFields(driverInfo) {
    driverInfo.birthDate = this.convertDateOnlyToDisplay(driverInfo.birthDate);
    driverInfo.annualReviewDate = this.convertDateOnlyToDisplay(driverInfo.annualReviewDate);
    driverInfo.expirationDateCGMP = this.convertDateOnlyToDisplay(driverInfo.expirationDateCGMP);
    driverInfo.hazmatTrainingDate = this.convertDateOnlyToDisplay(driverInfo.hazmatTrainingDate);
    driverInfo.hazmatTrainingExpirationDate = this.convertDateOnlyToDisplay(
      driverInfo.hazmatTrainingExpirationDate
    );
    driverInfo.hiredDate = this.convertDateOnlyToDisplay(driverInfo.hiredDate);
    driverInfo.hiredDateTo = this.convertDateOnlyToDisplay(driverInfo.hiredDateTo);
    driverInfo.hmeExpirationDate = this.convertDateOnlyToDisplay(driverInfo.hmeExpirationDate);
    driverInfo.licenseExpirationDate = this.convertDateOnlyToDisplay(
      driverInfo.licenseExpirationDate
    );
    driverInfo.passportExpirationDate = this.convertDateOnlyToDisplay(
      driverInfo.passportExpirationDate
    );
    driverInfo.physicalExamDate = this.convertDateOnlyToDisplay(driverInfo.physicalExamDate);
    driverInfo.physicalExamExpirationDate = this.convertDateOnlyToDisplay(
      driverInfo.physicalExamExpirationDate
    );
    driverInfo.trainingDateCGMP = this.convertDateOnlyToDisplay(driverInfo.trainingDateCGMP);
    driverInfo.terminationDate = this.convertDateOnlyToDisplay(driverInfo.terminationDate);

    if (driverInfo.driverHireDates) {
      driverInfo.driverHireDates = driverInfo.driverHireDates.map((hireDate) => ({
        ...hireDate,
        hiredDate: this.convertDateOnlyToDisplay(hireDate.hiredDate),
        hiredDateTo: this.convertDateOnlyToDisplay(hireDate.hiredDateTo),
      }));
    }
  }

  getPicturePath(name: string) {
    return this.getPictureService.getPicturePath(name, this.docType);
  }

  loadOwnerValue() {
    const { name, lastName } = this.driverInfo;
    if (lastName && name) {
      return (lastName.slice(0, 4) + name.slice(0, 4)).toUpperCase();
    }
    return "";
  }

  calculatehazmatTrainingExpirationDate(hazmatTrainingDate) {
    if (hazmatTrainingDate instanceof Date && !isNaN(hazmatTrainingDate.getTime())) {
      const year = hazmatTrainingDate.getFullYear();
      const month = hazmatTrainingDate.getMonth();
      const day = hazmatTrainingDate.getDate();

      this.driverInfo.hazmatTrainingExpirationDate = new Date(year + 3, month, day);
    } else {
      delete this.driverInfo.hazmatTrainingExpirationDate;
    }
  }

  calculateTrainingDateCGMPExpirationDate(CGMPExpirationDate) {
    if (CGMPExpirationDate instanceof Date && !isNaN(CGMPExpirationDate.getTime())) {
      const year = CGMPExpirationDate.getFullYear();
      const month = CGMPExpirationDate.getMonth();
      const day = CGMPExpirationDate.getDate();

      this.driverInfo.expirationDateCGMP = new Date(year + 1, month, day);
    } else {
      delete this.driverInfo.expirationDateCGMP;
    }
  }

  cancelEdit() {
    this.is_edit = true;
    this.btnProfile = "Edit Profile";
    this.driverInfo = JSON.parse(this.originalInfo);
    this.initDateFields(this.driverInfo);
  }

  getFilePath(path) {
    return this.getPictureService.getPicturePath(path, this.docType);
  }

  getTemporalImage(event) {
    if (event.target.files && event.target.files[0]) {
      this.newProfileFile = event.target.files[0];
      this.profilePicture = this.getPictureService.getPreviewImage(event.target.files[0]);
    }
  }

  uploadNewImage() {
    return this.fileUploadService.uploadSingleFileRename(
      [this.newProfileFile],
      this.docType,
      this.driverInfo.driverNo + "_" + this.newProfileFile.name
    );
  }

  uploadDocuments(driverId: string) {
    return this.driverDocuments.uploadDocuments(
      { DriverId: driverId },
      this.docType + "_files",
      driverId
    );
  }

  updateDriver(driver) {
    let errors = this.driverValidationService.validate(driver);
    if (errors && errors.length > 0) {
      this.isProcessing = false;
      for (const error of errors) {
        this.toastr.warning(error, "Alert!");
      }
      return;
    }

    this.addHireDates(driver.id).subscribe({
      next: () => {
        this.prepareDateOnlyFields();
        this.driverService.updateDriver(driver).subscribe({
          next: () => {
            this.originalInfo = JSON.stringify(driver);
            this.isProcessing = false;
            this.is_edit = true;
            this.router.navigate(["/drivers-list"]);
          },
          error: (errors) => {
            if (Array.isArray(errors)) {
              for (const error of errors) {
                this.toastr.warning(error, "Alert!", {
                  closeButton: true,
                  enableHtml: true,
                });
              }
            } else if (typeof errors === "string") {
              this.toastr.warning(errors, "Alert!", { closeButton: true, enableHtml: true });
            } else {
              this.toastr.error("An error occurred saving the driver", "Error");
            }
            this.isProcessing = false;
          },
        });
      },
      error: (error) => {
        this.toastr.warning(error, "Alert!");
        console.dir(error);
        this.isProcessing = false;
      },
    });
  }

  isPayToChanged(driver) {
    if (this.driverInfo.team && this.driverInfo.team.drivers) {
      for (let i = 0; i < this.driverInfo.team.drivers.length; i++) {
        let driver = this.driverInfo.team.drivers[i];
        let warned = false;
        this.driverService
          .getCurrentBatchStatus(driver.id)
          .subscribe((batchStatusResponse: any) => {
            if (batchStatusResponse.status !== "CLOSED") {
              this.toastr.warning(
                "This team has a batch ongoing, saving your changes will remove this driver from the batch."
              );
              warned = true;
            }
          });
        if (warned) break;
      }
    }

    this.driverInfo.team.drivers.forEach((d) => {
      if (d.id != driver.id) {
        d.isPayTo = !driver.isPayTo;
      }
    });
    if (driver.id != this.driverInfo.id) this.driverInfo.isPayTo = !driver.isPayTo;
  }

  earningPercentageChanged(driver: DriverViewModel) {
    if (driver.id === this.driverInfo.id) {
      this.driverInfo.earningPercentage = driver.earningPercentage;
    }
  }

  driverTypeChanged() {
    if (!this.driverInfo.team) this.driverInfo.isPayTo = true;
    this.filterTeamDrivers();
  }

  validateDriver() {
    if (this.driverInfo.team?.drivers) {
      const totalPercent = this.calculateTotalTeamPercent();
      if (totalPercent !== 100) {
        this.toastr.warning("Total percent must equal 100%", "Alert!");
        return false;
      }
    }
    return true;
  }

  nextDriver() {
    const currentIndex = this.allDrivers.findIndex((d) => d.id === this.driverInfo.id);
    let nextIndex = currentIndex + 1;
    if (nextIndex >= this.allDrivers.length) {
      nextIndex = 0;
    }
    const id = this.allDrivers[nextIndex].id;
    this.router.navigate([`/driverinfo/${id}`]).then(() => {
      this.ngOnInit();
    });
  }

  previousDriver() {
    const currentIndex = this.allDrivers.findIndex((d) => d.id === this.driverInfo.id);
    let prevIndex = currentIndex - 1;
    if (prevIndex < 0) {
      prevIndex = this.allDrivers.length - 1;
    }
    const id = this.allDrivers[prevIndex].id;
    this.router.navigate([`/driverinfo/${id}`]).then(() => {
      this.ngOnInit();
    });
  }
}
